import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzCascaderModule } from 'ng-zorro-antd/cascader';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { MRulesAddComponent } from './rules-add.component';
import { MRulesGroupComponent } from './rules-group.component';
import { MRulesItemComponent } from './rules-item.component';
import { MRulesLinkComponent } from './rules-link.component';
import { MRulesComponent } from './rules.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzSpaceModule,
    NzInputModule,
    NzSelectModule,
    NzCascaderModule,
    NzIconModule,
    NzToolTipModule,
    NzFormModule
  ],
  exports: [MRulesComponent, MRulesGroupComponent, MRulesItemComponent, MRulesAddComponent, MRulesLinkComponent],
  declarations: [MRulesComponent, MRulesGroupComponent, MRulesItemComponent, MRulesAddComponent, MRulesLinkComponent],
  providers: []
})
export class MRulesModule {}
